export class JiGuangRenZhengVo {
    public loginToken=''
}
